import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root',
})
export class SubdomainService {
    getSubdomain() {
        if (this.isIpAddress())
            return '';

        const domain = window.location.hostname;
        let subdomain = domain.split('.')[0];

        const tokens = ['example', 'lvh', 'www', 'localhost', 'ms'];

        if (tokens.indexOf(subdomain) !== -1)
            subdomain = '';

        return subdomain;
    }

    private isIpAddress = (): boolean => {
        const tokens = window.location.hostname.split('.');

        for (let x = 0; x < tokens.length; x++)
            if (isNaN(Number(tokens[x])))
                return false;

        return true;
    }
}